<template>
    <Layout>
        <div>
            Search Page
        </div>
        <div
            v-for="website in websites"
            v-bind:key="website.id"
        >
            <a
                v-bind:href="website.urls[0].url"
            >
                {{ website.title }}
            </a>
            <span>
                {{ website.urls[0].url }}
            </span>
        </div>
    </Layout>
</template>

<script>
    import Layout from '@layouts/main';

    export default {
        /**
         * Custom page meta data property for the view components.
         *
         * @type {Object}
         */
        metaInfo: {
            title: 'Citizen J.',
            meta: [
                {
                    name: 'description',
                    content: 'Citizen J. Search Page',
                },
            ],
            link: [
                {
                    rel: 'canonical',
                    href: '/search',
                },
            ],
        },

        /**
         * Declaratively register required components.
         *
         * @link https://vuejs.org/v2/guide/components.html#Local-Registration
         */
        components: {
            Layout,
        },

        /**
         * You must define defaults for all Vue models and reactive Vue template data.
         *
         * @link https://vuejs.org/v2/api/#data
         *
         * @return Object Vue model and binding defaults.
         */
        data () {
            return {
                websites: [],
            };
        },

        /**
         * This method logic will be run immediately after the Vue instance is created.
         *
         * @link https://vuejs.org/v2/guide/instance.html#Lifecycle-Diagram
         */
        created () {
            this.axios
                .get('/search', {
                    params: {
                        query: this.$route.query.query,
                    },
                })
                .then(({ data }) => this.websites = data);
        },
    };
</script>
